const makeDateSort = (getValue: (x) => string) => (a, b) => {
  const aParsed = Date.parse(getValue(a));
  const bParsed = Date.parse(getValue(b));
  if (isNaN(aParsed)) {
    return 1;
  } else if (isNaN(bParsed)) {
    return -1;
  }

  if (aParsed < bParsed) {
    return 1;
  }
  if (aParsed > bParsed) {
    return -1;
  }
  return 0;
};

const sortRecentHighlight = makeDateSort(
  (highlight) => highlight.lastModifiedAt
);

export const sortRecentMarker = makeDateSort((marker) => marker.lastUsedAt);

export const lastUsedMarkers = (highlights) => {
  if (highlights && highlights.length > 0) {
    return highlights.sort(sortRecentHighlight).reduce((result, highlight) => {
      if (!result[highlight.markerId]) {
        result[highlight.markerId] = highlight.lastModifiedAt;
      }
      return result;
    }, {});
  }
  return {};
};
